import React, { FC, useCallback, useEffect, useState } from "react";
import Heading from "components/Heading/Heading";
import ProductCard from "./ProductCard";
import { Product, PRODUCTS } from "data/data";

import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

export interface SectionSliderProductCardProps {
  className?: string;
  itemClassName?: string;
  heading?: string;
  headingFontClassName?: string;
  headingClassName?: string;
  subHeading?: string;
  data?: Product[];
}

const SectionSliderProductCard: FC<SectionSliderProductCardProps> = ({
  className = "",
  itemClassName = "",
  headingFontClassName,
  headingClassName,
  heading,
  subHeading = "REY backpacks & bags",
  data = PRODUCTS.filter((_, i) => i < 8 && i > 2),
}) => {
  const [emblaRef, embla] = useEmblaCarousel(
    {
      loop: true,
      align: "start",
      slidesToScroll: 1,
      dragFree: true,
    },
    [
      Autoplay({
        delay: 2500,
        stopOnInteraction: false,
      }),
    ]
  );

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);
  useEffect(() => {
    if (!embla) return;

    const onSelect = () => {
      setSelectedIndex(embla.selectedScrollSnap());
    };

    embla.on("select", onSelect);
    setScrollSnaps(embla.scrollSnapList().map((_, i) => i));

    return () => {
      embla.off("select", onSelect); // ✅ cleanup returns void
    };
  }, [embla]);

  return (
    <div className={`nc-SectionSliderProductCard ${className}`}>
      <Heading className={headingClassName} fontClass={headingFontClassName}>
        {heading || "Our Products"}
      </Heading>

      {/* Embla */}
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex">
          {data.map((item, index) => (
            <div
              key={index}
              className={`
                flex-shrink-0
                px-4
                w-full
                sm:w-[85%]
                md:w-1/2
                lg:w-1/3
                xl:w-1/4
                ${itemClassName}
              `}
            >
              <ProductCard data={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionSliderProductCard;
